import styled from "styled-components";

const MenuItem = styled.button`
  padding: 10px;
  color: #333333;
  cursor: pointer;
  transition: background-color 0.1s;
  background: #ffffff;
  border: none;
  font-size: 14px;
  display: block;
  width: 100%;
  text-align: left;

  &:hover {
    background-color: #eefbff;
  }
`;

export default MenuItem;
